const origin = location.origin
const apiUrl = origin.indexOf('localhost') > 0 /*|| location.port === '8080'*/? `http://${location.hostname}:8081` : origin
const imgUrl = `${apiUrl}/fs/z2`
const hlsUrl = `${apiUrl}/hls`
export {apiUrl, imgUrl, hlsUrl}
